import { Layout, theme } from 'antd';
import React, { useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import Footers from '../components/Footer';
import Headers from '../components/Header';
import Siders from '../components/Sider';
import App from '../components/Stats';
import Hesabat from './Hesabat';


const { Content } = Layout;

const HesabatMain = () => {
  const [permissions, setPermissions] = useState({});
  const navigate = useNavigate();

  const {
    token: { colorBgContainer },
  } = theme.useToken();

  useEffect(() => {
    // Fetch permissions from session storage
    const storedPermissions = JSON.parse(localStorage.getItem('permissions'));
    if (storedPermissions && storedPermissions.length > 0) {
      setPermissions(storedPermissions[0]);
      // Redirect if no GuidesAzAdd permission
      if (storedPermissions[0].HesabatMain === 0) {
        navigate("/");
      }
    }
  }, [navigate]);

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Siders />
      <Layout>
        {/* <Headers /> */}
        <Content className="site-layout" >
          <App />
          <br />
          <div style={{ padding: 24, minHeight: 380, background: colorBgContainer }}>
            <Hesabat />
          </div>
        </Content>
        {/* <Footers /> */}
      </Layout>
    </Layout>
  );
};

export default HesabatMain;
